import {
  IConfigWeb,
  IConfigWebColors,
  IConfigWebColorsValidation,
  IConfigWebConfiguration,
  IConfigWebContactValidation,
  IConfigWebImages,
} from '../types';
import { defaulLangTextValidation, defaultTTranslate, defaultValidation, LOCALES } from 'src/constants/main';

export const defaultConfigWebColors: IConfigWebColors = {
  headerBackgroundFirstColor: '#ffffff',
  headerBackgroundSecondColor: '#ffffff',
  headerPlaneTextColor: '#ffffff',
  headerBackgroundSelectedColor: '#ffffff',
  headerBackgroundSelectedTextColor: '#ffffff',
  buttonsColor: '#ffffff',
  buttonsTextColor: '#ffffff',
  css: '',
};

export const defaultConfigWebImages: IConfigWebImages = {
  bannerImage: '',
  appBannerIcon: '',
  webHeaderLogo: '',
  webFooterLogo: '',
  favicon: '',
};

export const defaultConfigWebConfiguration: IConfigWebConfiguration = {
  defaultLanguage: LOCALES.EN,
  is_human_readable_url: false,
  webContact: {
    businessName: { en: '', ar: '' },
    email: '',
    mobile: '',
    isMobileHidden: 0,
    copyright: '',
    address: '',
  },
  metaDetails: {
    keyword: defaultTTranslate,
    description: defaultTTranslate,
  },
  appLinks: {
    ios: '',
    android: '',
    oneLink: '',
  },
  socialLinks: {
    facebook: '',
    instagram: '',
    twitter: '',
    whatsApp: '',
    youtube: '',
    tiktok: '',
    snapchat: '',
  },
};

export const defaultConfigWeb: IConfigWeb = {
  colors: defaultConfigWebColors,
  images: defaultConfigWebImages,
  configuration: defaultConfigWebConfiguration,
};

export const defaultConfigWebColorsValidation: IConfigWebColorsValidation = {
  isValid: true,
  headerBackgroundFirstColor: defaultValidation,
  headerBackgroundSecondColor: defaultValidation,
  headerPlaneTextColor: defaultValidation,
  headerBackgroundSelectedColor: defaultValidation,
  headerBackgroundSelectedTextColor: defaultValidation,
  buttonsColor: defaultValidation,
  buttonsTextColor: defaultValidation,
};

export const defaultConfigWebContactValidation: IConfigWebContactValidation = {
  isValid: true,
  businessName: defaulLangTextValidation,
  email: defaultValidation,
  mobile: defaultValidation,
};
